"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateExtremelyFineGranularityFreqArray = generateExtremelyFineGranularityFreqArray;
exports.generateFineGranularityFreqArray = generateFineGranularityFreqArray;
exports.generateModerateGranularityFreqArray = generateModerateGranularityFreqArray;
exports.generateVeryFineGranularityFreqArray = generateVeryFineGranularityFreqArray;
// const POINTS_PER_DECADE_58 /* vs 50 */ = [
//   // by 0.05 (mostly)
//   1.00, 1.05, 1.10, 1.15, 1.20, 1.25, 1.30, 1.35, 1.40, 1.45, 1.50, 
//   // by 0.10
//   1.60, 1.70, 1.80, 1.90, 2.00, 2.10, 2.20, 2.30, 2.40, 2.50, 2.60, 2.70, 2.80, 2.90, 3.00, 3.10, 3.20, 
//   // by 0.15
//   3.35, 3.50, 3.70, 3.85, 4.00, 4.15, 4.30, 
//   // by 0.20 (mostly)
//   4.50, 4.70, 4.85, 5.00, 5.20, 5.40, 5.60, 5.80, 6.00, 
//   // by 0.25
//   6.25, 6.50, 6.75, 7.00, 7.25, 7.50, 8.00, 8.25, 8.50, 8.75, 9.00, 9.25, 9.75, 10.00,
// ];

const POINTS_PER_DECADE_63 /* vs 50 */ = [
// by 0.05 (mostly)
1.00, 1.05, 1.10, 1.15, 1.20, 1.25, 1.30, 1.35, 1.40, 1.45, 1.50, 1.55, 1.60, 1.65, 1.70, 1.75, 1.80, 1.85, 1.90, 1.95, 2.00,
// by 0.10
2.10, 2.20, 2.30, 2.40, 2.50, 2.60, 2.70, 2.80, 2.90, 3.00, 3.10, 3.20,
// by 0.15
3.35, 3.50, 3.70, 3.85, 4.00, 4.15, 4.30,
// by 0.20 (mostly)
4.50, 4.70, 4.85, 5.00, 5.20, 5.40, 5.60, 5.80, 6.00,
// by 0.25
6.25, 6.50, 6.75, 7.00, 7.25, 7.50, 8.00, 8.25, 8.50, 8.75, 9.00, 9.25, 9.75, 10.00];
const POINTS_PER_DECADE_99 /* vs 101 */ = [
// by 0.02
1.00, 1.02, 1.04, 1.06, 1.08, 1.10,
// by 0.025 (0.02/0.03/0.03/0.02)
1.12, 1.15, 1.18, 1.20, 1.22, 1.25, 1.28, 1.30, 1.32, 1.35, 1.38, 1.40, 1.42, 1.45, 1.48, 1.50,
// by 0.05
1.55, 1.60, 1.65, 1.70, 1.75, 1.80, 1.85, 1.90, 1.95, 2.00, 2.05, 2.10, 2.15, 2.20, 2.25, 2.30, 2.35, 2.40, 2.45, 2.50, 2.55, 2.60, 2.70, 2.75, 2.80, 2.85, 2.90, 2.95, 3.00, 3.05, 3.10, 3.15, 3.20,
// by 0.10
3.30, 3.40, 3.50, 3.60, 3.70, 3.90, 4.00, 4.10, 4.20,
// by 0.125 (0.12/0.13/0.13/0.12)
4.32, 4.45, 4.58, 4.75, 4.88, 5.00,
// by 0.15
5.15, 5.30, 5.50, 5.65, 5.80, 6.00, 6.15, 6.30, 6.45, 6.60, 6.75, 6.88, 7.00, 7.15, 7.32, 7.50, 7.65, 7.80,
//by 0.20
8.00, 8.20, 8.40, 8.60, 8.80, 9.00, 9.20, 9.40, 9.60, 9.80, 10];
const POINTS_PER_DECADE_607 /* vs 603 */ = [
// by 0.005
1.005, 1.010, 1.015, 1.020, 1.025, 1.030, 1.035, 1.040, 1.045, 1.050, 1.055, 1.060, 1.065, 1.070, 1.075, 1.080, 1.085, 1.090, 1.095, 1.100, 1.105, 1.110, 1.115, 1.120, 1.125, 1.130, 1.135, 1.140, 1.145, 1.150, 1.155, 1.160, 1.165, 1.170, 1.175, 1.180, 1.185, 1.190, 1.195, 1.200, 1.205, 1.210, 1.215, 1.220, 1.225, 1.230, 1.235, 1.240, 1.245, 1.250, 1.255, 1.260, 1.265, 1.270, 1.275, 1.280, 1.285, 1.290, 1.295, 1.300, 1.305, 1.310, 1.315, 1.320, 1.325, 1.330, 1.335, 1.340, 1.345, 1.350, 1.355, 1.360, 1.365, 1.370, 1.375, 1.380, 1.385, 1.390, 1.395, 1.400, 1.405, 1.410, 1.415, 1.420, 1.425, 1.430, 1.435, 1.440, 1.445, 1.450, 1.455, 1.460, 1.465, 1.470, 1.475, 1.480, 1.485, 1.490, 1.495, 1.500, 1.505, 1.510, 1.515, 1.520, 1.525, 1.530, 1.535, 1.540, 1.545, 1.550, 1.555, 1.560, 1.565, 1.570, 1.575, 1.580, 1.585, 1.590, 1.595, 1.600,
// by 0.0075  (.008/.007/0.007/0.008)
1.608, 1.615, 1.622, 1.630, 1.638, 1.645, 1.652, 1.660, 1.668, 1.675, 1.682, 1.690, 1.698, 1.705, 1.712, 1.720, 1.728, 1.735, 1.742, 1.750, 1.758, 1.765, 1.772, 1.780, 1.788, 1.795, 1.802, 1.810, 1.818, 1.825, 1.832, 1.840, 1.848, 1.855, 1.862, 1.870, 1.878, 1.885, 1.892, 1.900, 1.908, 1.915, 1.922, 1.930, 1.938, 1.945, 1.952, 1.960, 1.968, 1.975, 1.981, 1.987, 1.993, 2.000, 2.006, 2.013, 2.020, 2.028, 2.035, 2.042, 2.050, 2.057, 2.065, 2.072, 2.080, 2.088, 2.095, 2.102, 2.110, 2.118, 2.125, 2.133, 2.140, 2.148, 2.155, 2.162, 2.170, 2.178, 2.185, 2.192, 2.200, 2.208, 2.216, 2.225, 2.231, 2.238, 2.244, 2.250, 2.259, 2.267, 2.275, 2.282, 2.290, 2.298, 2.305, 2.312, 2.320, 2.328, 2.335, 2.342, 2.350, 2.358, 2.365, 2.372, 2.380,
// by 0.01
2.390, 2.400, 2.410, 2.420, 2.430, 2.440, 2.450, 2.460, 2.470, 2.480, 2.490, 2.500, 2.510, 2.520, 2.530, 2.540, 2.550, 2.560, 2.570, 2.580, 2.590, 2.600, 2.610, 2.620, 2.630, 2.640, 2.650, 2.660, 2.670, 2.680, 2.690, 2.700, 2.710, 2.720, 2.730, 2.740, 2.750, 2.760, 2.770, 2.780, 2.790, 2.800, 2.810, 2.820, 2.830, 2.840, 2.850, 2.860, 2.87, 2.88, 2.89, 2.9, 2.91, 2.92, 2.93, 2.94, 2.95, 2.96, 2.97, 2.98, 2.99, 3.0, 3.01, 3.02, 3.03, 3.04, 3.05, 3.06, 3.07, 3.08, 3.09, 3.1, 3.11, 3.12, 3.13, 3.14, 3.15, 3.16, 3.17, 3.18, 3.19, 3.2, 3.21, 3.22, 3.23, 3.24, 3.25, 3.26, 3.27, 3.28, 3.29, 3.3, 3.31, 3.32, 3.33, 3.34, 3.35, 3.36, 3.37, 3.38, 3.39,
// by 0.02
3.4, 3.42, 3.44, 3.46, 3.48, 3.5, 3.52, 3.54, 3.56, 3.58, 3.6, 3.62, 3.64, 3.66, 3.68, 3.7, 3.72, 3.74, 3.76, 3.78, 3.8, 3.82, 3.84, 3.86, 3.88, 3.9, 3.92, 3.93, 3.96, 3.98, 4.0, 4.02, 4.04, 4.06, 4.08, 4.1, 4.12, 4.14, 4.16, 4.18, 4.2, 4.22, 4.24, 4.26, 4.28, 4.3, 4.32, 4.34, 4.36, 4.38, 4.4, 4.42, 4.44, 4.46, 4.48, 4.5, 4.52, 4.54, 4.56, 4.58, 4.6, 4.62, 4.64, 4.66, 4.68, 4.7, 4.72, 4.74, 4.76, 4.78, 4.8, 4.82, 4.84, 4.86, 4.88, 4.9, 4.92, 4.94, 4.96, 4.98, 5.0, 5.02, 5.04, 5.06, 5.08, 5.1, 5.12, 5.14, 5.16, 5.18, 5.2, 5.22, 5.24, 5.26, 5.28, 5.3, 5.32, 5.34, 5.36, 5.38, 5.4, 5.42, 5.44, 5.46, 5.48, 5.5, 5.52, 5.54, 5.56, 5.58, 5.6, 5.62, 5.64, 5.66, 5.68, 5.7, 5.72, 5.74, 5.76, 5.78, 5.8, 5.82, 5.84, 5.86, 5.88, 5.9, 5.92, 5.94, 5.96, 5.98, 6.0, 6.02, 6.04, 6.06, 6.08, 6.1, 6.12, 6.14, 6.16, 6.18, 6.2, 6.22, 6.24, 6.26, 6.28, 6.3, 6.32, 6.34, 6.36, 6.38, 6.4, 6.42, 6.44, 6.46, 6.48, 6.5, 6.52, 6.54, 6.56, 6.58, 6.6, 6.62, 6.64, 6.66, 6.68, 6.7, 6.72, 6.74, 6.76, 6.78, 6.80, 6.82, 6.84, 6.86, 6.88, 6.90, 6.92, 6.94, 6.96, 6.98, 7.00,
// 0.025 => (0.02/0.03/0.03/0.02)
7.02, 7.05, 7.08, 7.10, 7.12, 7.15, 7.18, 7.20, 7.22, 7.25, 7.28, 7.30, 7.32, 7.35, 7.38, 7.40, 7.42, 7.45, 7.48, 7.50, 7.52, 7.55, 7.58, 7.60, 7.62, 7.65, 7.68, 7.70, 7.72, 7.75, 7.78, 7.80, 7.82, 7.85, 7.88, 7.90, 7.92, 7.95, 7.98, 8.00, 8.02, 8.05, 8.08, 8.10, 8.12, 8.15, 8.18, 8.20, 8.22, 8.25, 8.28, 8.30, 8.32, 8.35, 8.38, 8.40, 8.42, 8.45, 8.48, 8.50, 8.52, 8.55, 8.58, 8.60, 8.62, 8.65, 8.68, 8.70, 8.72, 8.75, 8.78, 8.80, 8.82, 8.85, 8.88, 8.90, 8.92, 8.95, 8.98, 9.00,
// 0.05
9.05, 9.10, 9.15, 9.20, 9.25, 9.30, 9.35, 9.4, 9.45, 9.50, 9.55, 9.60, 9.65, 9.70, 9.75, 9.80, 9.85, 9.90, 9.95, 10.0];

/**
 * Total of 50 points per decade
 * @param {*} start first frequency in array
 * @param {*} stop last frequency in array.  Must be bigger than start.
 * @param {*} expectedPoints (optional): Array of points that are expected in each decade.  Overrides POINTS_PER_DECADE constant.  For example passing in [1,2] will result in 1, 2, 10, 20, 100, 200, etc.
 */
function generateModerateGranularityFreqArray(start, stop, expectedPoints) {
  // eslint-disable-next-line no-unused-vars
  const POINTS_PER_DECADE = [
  // by 0.05
  1.07, 1.12, 1.17,
  // by 0.06
  1.23, 1.29, 1.35, 1.41,
  // by 0.07
  1.48, 1.55, 1.62,
  // by 0.08
  1.70, 1.78, 1.86,
  // by 0.09
  1.95, 2.04,
  // by 0.10
  2.14, 2.24,
  // by 0.11
  2.35, 2.46, 2.57,
  // by 0.13
  2.7, 2.82,
  // by 0.14
  2.96, 3.1, 3.24,
  // by 0.16
  3.4, 3.56, 3.72,
  // by 0.18
  3.9, 4.08,
  // by 0.20
  4.28, 4.48,
  // by 0.21
  4.69,
  // by 0.22
  4.91,
  // by 0.23
  5.14,
  // by 0.24
  5.38,
  // by 0.26
  5.64, 5.9,
  // by 0.28
  6.18,
  // by 0.30
  6.48, 6.78,
  // by 0.32
  7.1,
  // by 0.34
  7.44,
  // by 0.35
  7.79,
  // by 0.37
  8.16,
  // by 0.38
  8.54,
  // by 0.40
  8.94,
  // by 0.42
  9.36,
  // by 0.44
  9.8,
  // by 0.46
  10.26];
  return generateFreqArray(start, stop, expectedPoints, POINTS_PER_DECADE_63);
}

/**
 * Total of 101 points per decade
 * @param {*} start first frequency in array
 * @param {*} stop last frequency in array.  Must be bigger than start.
 * @param {*} expectedPoints (optional): Array of points that are expected in each decade.  Overrides POINTS_PER_DECADE constant.  For example passing in [1,2] will result in 1, 2, 10, 20, 100, 200, etc.
 */
function generateFineGranularityFreqArray(start, stop, expectedPoints) {
  // eslint-disable-next-line no-unused-vars
  const POINTS_PER_DECADE = [1,
  //by 0.02
  1.02, 1.05, 1.07, 1.09,
  //by 0.03
  1.12, 1.15, 1.17, 1.2, 1.23, 1.26, 1.29, 1.32, 1.35, 1.38, 1.41, 1.44, 1.47,
  //by 0.04
  1.51, 1.55, 1.59, 1.62, 1.66, 1.7, 1.74, 1.78, 1.82, 1.86, 1.9, 1.94,
  //by 0.05
  1.99, 2.04, 2.09, 2.14, 2.19, 2.24, 2.29, 2.34, 2.39,
  //by 0.06
  2.45, 2.51, 2.57, 2.63, 2.69, 2.75, 2.81,
  //by 0.07
  2.88, 2.95, 3.02, 3.09, 3.16, 3.23,
  //by 0.08
  3.31, 3.39, 3.47, 3.55, 3.63, 3.71,
  //by 0.09
  3.8, 3.89, 3.98, 4.07,
  //by 0.1
  4.17, 4.27, 4.37, 4.47, 4.57,
  //by 0.11
  4.68, 4.79, 4.9, 5.01,
  //by 0.12
  5.13, 5.25, 5.37, 5.49,
  //by 0.13
  5.62, 5.75,
  //by 0.14
  5.89, 6.03, 6.17, 6.31,
  //by 0.15
  6.46, 6.61, 6.76,
  // 0.16
  6.92, 7.08, 7.24,
  //by 0.17
  7.41, 7.58,
  //by 0.18
  7.76, 7.94,
  //by 0.19
  8.13, 8.32, 8.51,
  //by 0.2
  8.71, 8.91,
  //by 0.21
  9.12, 9.33,
  //by 0.22
  9.55, 9.77,
  //by 0.23
  10];
  return generateFreqArray(start, stop, expectedPoints, POINTS_PER_DECADE_99);
}

/**
 * Total of 110 points per decade
 * @param {*} start first frequency in array
 * @param {*} stop last frequency in array.  Must be bigger than start.
 * @param {*} expectedPoints (optional): Array of points that are expected in each decade.  Overrides POINTS_PER_DECADE constant.  For example passing in [1,2] will result in 1, 2, 10, 20, 100, 200, etc.
 */
function generateVeryFineGranularityFreqArray(start, stop, expectedPoints) {
  // eslint-disable-next-line no-unused-vars
  const POINTS_PER_DECADE = [
  //by 0.02
  1.02, 1.04, 1.06, 1.08, 1.1,
  //by 0.03
  1.13, 1.16, 1.18, 1.21, 1.23, 1.26, 1.28, 1.31, 1.34, 1.37, 1.4, 1.43, 1.46, 1.49, 1.52, 1.55, 1.58, 1.61,
  //by 0.04
  1.65, 1.69, 1.72, 1.76, 1.8, 1.83, 1.87, 1.91, 1.95, 1.99,
  //by 0.05
  2.03, 2.08, 2.12, 2.17, 2.21, 2.26, 2.31, 2.36, 2.41, 2.46, 2.51,
  //by 0.06
  2.56, 2.62, 2.67, 2.73, 2.79, 2.85, 2.91, 2.97, 3.03, 3.09,
  //by 0.07
  3.16, 3.23, 3.3, 3.37, 3.44, 3.51, 3.58,
  //by 0.08
  3.66, 3.74, 3.82, 3.9, 3.98, 4.06,
  //by 0.09
  4.15, 4.24, 4.33, 4.42, 4.51, 4.6,
  //by 0.1
  4.7, 4.8, 4.91, 5.01, 5.11,
  //by 0.11
  5.22, 5.33, 5.44,
  //by 0.12
  5.56, 5.68, 5.8, 5.92,
  //by 0.13
  6.05, 6.18, 6.31, 6.44,
  //by 0.14
  6.58, 6.72, 6.86, 7.0,
  //by 0.15
  7.15, 7.3,
  //by 0.16
  7.46, 7.62, 7.78, 7.94,
  //by 0.17
  8.11, 8.28,
  //by 0.18
  8.46, 8.64, 8.82,
  //by 0.19
  9.01, 9.2, 9.39,
  //by 0.2
  9.59, 9.79,
  //by 0.21
  10];
  return generateFreqArray(start, stop, expectedPoints, POINTS_PER_DECADE_99);
}

/**
 * Total of 603 points per decade
 * @param {*} start first frequency in array
 * @param {*} stop last frequency in array.  Must be bigger than start.
 * @param {*} expectedPoints (optional): Array of points that are expected in each decade.  Overrides POINTS_PER_DECADE constant.  For example passing in [1,2] will result in 1, 2, 10, 20, 100, 200, etc.
 */
function generateExtremelyFineGranularityFreqArray(start, stop, expectedPoints) {
  // eslint-disable-next-line no-unused-vars
  const POINTS_PER_DECADE = [
  // by 0.004
  1.004, 1.008, 1.012, 1.016, 1.02, 1.024, 1.028, 1.032, 1.036, 1.04, 1.044, 1.048, 1.052, 1.056, 1.06, 1.064, 1.068, 1.072, 1.076, 1.08,
  // by 0.005
  1.084, 1.089, 1.094, 1.099, 1.104, 1.109, 1.114, 1.119, 1.124, 1.129, 1.134, 1.139, 1.144, 1.149, 1.154, 1.159, 1.164, 1.169, 1.174, 1.179, 1.184, 1.189, 1.194, 1.199, 1.204, 1.209, 1.214, 1.219, 1.224, 1.229, 1.234, 1.239, 1.244, 1.249, 1.254, 1.259, 1.264, 1.269, 1.274, 1.279, 1.284, 1.289, 1.294, 1.299, 1.304, 1.309, 1.314, 1.319, 1.324, 1.329, 1.334, 1.339, 1.344, 1.349, 1.354, 1.359, 1.364, 1.369, 1.374, 1.379, 1.384, 1.389, 1.394, 1.399, 1.404, 1.409, 1.414, 1.419, 1.424, 1.429, 1.434, 1.439, 1.444, 1.449, 1.454, 1.459, 1.464, 1.469, 1.474, 1.479, 1.484, 1.489, 1.494, 1.499, 1.504,
  // by 0.006
  1.509, 1.515, 1.521, 1.527, 1.533, 1.539, 1.545, 1.551, 1.557, 1.563, 1.569, 1.575, 1.581, 1.587, 1.593,
  // by 0.007
  1.599, 1.606, 1.613, 1.62, 1.627, 1.634, 1.641, 1.648, 1.655, 1.662, 1.669, 1.676, 1.683, 1.69, 1.697, 1.704, 1.711, 1.718, 1.725, 1.732, 1.739, 1.746, 1.753, 1.76, 1.767, 1.774, 1.781, 1.788, 1.795, 1.802, 1.809, 1.816, 1.823, 1.83, 1.837, 1.844, 1.851, 1.858, 1.865, 1.872, 1.879, 1.886, 1.893, 1.9, 1.907, 1.914, 1.921, 1.928, 1.935, 1.942, 1.949, 1.956, 1.963, 1.97, 1.977, 1.984, 1.991, 1.998, 2.005, 2.012, 2.019, 2.026, 2.033, 2.04, 2.047, 2.054, 2.061, 2.068, 2.075, 2.082, 2.089, 2.096, 2.103, 2.11, 2.117, 2.124, 2.131, 2.138, 2.145,
  // by 0.008
  2.152, 2.16, 2.168, 2.176, 2.184, 2.192, 2.2, 2.208, 2.216, 2.224, 2.232, 2.24, 2.248,
  // by 0.009
  2.257, 2.266, 2.275, 2.284, 2.293, 2.302, 2.311, 2.32, 2.329, 2.338, 2.347, 2.356, 2.365, 2.374, 2.383, 2.392, 2.401, 2.41, 2.419, 2.428, 2.437, 2.446, 2.455, 2.464, 2.473, 2.482, 2.491, 2.5, 2.509, 2.518, 2.527, 2.536, 2.545, 2.554, 2.563, 2.572, 2.581, 2.59, 2.599, 2.608, 2.617, 2.626, 2.635, 2.644, 2.653, 2.662, 2.671, 2.68, 2.689, 2.698, 2.707, 2.716, 2.725, 2.734, 2.743, 2.752, 2.761, 2.77, 2.779, 2.788, 2.797, 2.806, 2.815, 2.824, 2.833, 2.842, 2.851, 2.86,
  //by 0.01
  2.87, 2.88, 2.89, 2.9, 2.91, 2.92, 2.93, 2.94, 2.95, 2.96, 2.97, 2.98, 2.99, 3.0, 3.01, 3.02, 3.03, 3.04, 3.05, 3.06, 3.07, 3.08, 3.09, 3.1, 3.11, 3.12, 3.13, 3.14, 3.15, 3.16, 3.17, 3.18, 3.19, 3.2, 3.21, 3.22, 3.23, 3.24, 3.25, 3.26, 3.27, 3.28, 3.29, 3.3, 3.31, 3.32, 3.33, 3.34, 3.35, 3.36, 3.37, 3.38, 3.39,
  //by 0.02
  3.4, 3.42, 3.44, 3.46, 3.48, 3.5, 3.52, 3.54, 3.56, 3.58, 3.6, 3.62, 3.64, 3.66, 3.68, 3.7, 3.72, 3.74, 3.76, 3.78, 3.8, 3.82, 3.84, 3.86, 3.88, 3.9, 3.92, 3.93, 3.96, 3.98, 4.0, 4.02, 4.04, 4.06, 4.08, 4.1, 4.12, 4.14, 4.16, 4.18, 4.2, 4.22, 4.24, 4.26, 4.28, 4.3, 4.32, 4.34, 4.36, 4.38, 4.4, 4.42, 4.44, 4.46, 4.48, 4.5, 4.52, 4.54, 4.56, 4.58, 4.6, 4.62, 4.64, 4.66, 4.68, 4.7, 4.72, 4.74, 4.76, 4.78, 4.8, 4.82, 4.84, 4.86, 4.88, 4.9, 4.92, 4.94, 4.96, 4.98, 5.0, 5.02, 5.04, 5.06, 5.08, 5.1, 5.12, 5.14, 5.16, 5.18, 5.2, 5.22, 5.24, 5.26, 5.28, 5.3, 5.32, 5.34, 5.36, 5.38, 5.4, 5.42, 5.44, 5.46, 5.48, 5.5, 5.52, 5.54, 5.56, 5.58, 5.6, 5.62, 5.64, 5.66, 5.68, 5.7, 5.72, 5.74, 5.76, 5.78, 5.8, 5.82, 5.84, 5.86, 5.88, 5.9, 5.92, 5.94, 5.96, 5.98, 6.0, 6.02, 6.04, 6.06, 6.08, 6.1, 6.12, 6.14, 6.16, 6.18, 6.2, 6.22, 6.24, 6.26, 6.28, 6.3, 6.32, 6.34, 6.36, 6.38, 6.4, 6.42, 6.44, 6.46, 6.48, 6.5, 6.52, 6.54, 6.56, 6.58, 6.6, 6.62, 6.64, 6.66, 6.68, 6.7, 6.72, 6.74, 6.76, 6.77,
  // 0.03
  6.79, 6.82, 6.85, 6.88, 6.91, 6.94, 6.97, 7.0, 7.03, 7.06, 7.09, 7.12, 7.15, 7.18, 7.21, 7.24, 7.27, 7.3, 7.33, 7.36, 7.39, 7.42, 7.45, 7.48, 7.51, 7.54, 7.57, 7.6, 7.63, 7.66, 7.69, 7.72, 7.75, 7.78, 7.81, 7.84, 7.87, 7.9, 7.93, 7.96, 7.99, 8.02, 8.05, 8.08, 8.11, 8.14, 8.17, 8.2, 8.23, 8.26, 8.29, 8.32, 8.35, 8.38, 8.41, 8.44, 8.47, 8.5, 8.53, 8.56, 8.59, 8.62, 8.65, 8.68, 8.71, 8.74, 8.77, 8.8, 8.83, 8.86, 8.89, 8.92, 8.95, 8.98, 9.01,
  // 0.04
  9.04, 9.08, 9.12, 9.16, 9.2, 9.24, 9.28, 9.32, 9.36, 9.4, 9.44, 9.48, 9.52, 9.56, 9.6, 9.64, 9.68, 9.72, 9.76, 9.8, 9.84, 9.88, 9.92, 9.96, 10.001];
  return generateFreqArray(start, stop, expectedPoints, POINTS_PER_DECADE_607);
}
function generateFreqArray(start, stop, expectedPoints, pointsPerDecade) {
  // error checking
  if (typeof start !== 'number') throw new Error('Cannot generate frequency array, start freq is not a number');
  if (typeof stop !== 'number') throw new Error('Cannot generate frequency array, stop freq is not a number');
  if (start <= 0) throw new Error('Cannot generate frequency array when start freq is <= 0');
  if (start >= stop) throw new Error('Cannot generate frequency array when start frequency is >= stop frequency');
  let results = [],
    currentPosition = start;
  const expectedPointsArr = expectedPoints || pointsPerDecade;
  let decadeStart = Math.floor(Math.log10(start));

  // Iterate through each decade and add the corresponding point values
  for (let decade = decadeStart; currentPosition < stop; decade++) {
    let newPoints = expectedPointsArr.map(value => Number(value + 'e' + decade)).filter(value => !results.includes(value)); // ensure we aren't adding duplicates

    results.push(...newPoints);
    currentPosition = results[results.length - 1] + 1;
  }

  // find index of the nearest start value
  const index = results.findIndex(value => value >= start);
  // if index is not 0, get the value before the index result above, this index will be the starting point of the array
  const startIndex = index === 0 ? index : index - 1;
  const endIndex = results.findIndex(value => value >= stop);
  const filteredResult = results.filter((_value, index) => {
    return index >= startIndex && index <= endIndex;
  });
  return filteredResult;
}